const STATIC = {
    arrowUp: 'visible',
    hide: 'is-hidden',
    opacity: '0.2'
}

function logoMobile() {
    const logosModule = document.querySelector('[data-js-module="lp-logos"]'),
        btn = document.querySelector('[data-js="lp-logos-btn"]');

    if(logosModule) {
        const logos = logosModule.querySelectorAll('[data-js="lp-logo"]');

        if((logos.length <= 4) && (btn)) {
            btn.classList.add(STATIC.hide)
        }
        else {
            let arrayHeight = [];

            for (let i =0; i<=3; i++) {
                const height = logos[i].offsetHeight;
                arrayHeight.push(height);
            }

            const halftHeight = (logos[4].offsetHeight)/2;
            arrayHeight.push(halftHeight);

            logos[4].style.opacity = STATIC.opacity;

            const sumLogosHeight = arrayHeight.reduce((a,b) => a + b, 0),
                logosHeight = `${sumLogosHeight}px`;

            logosModule.style.maxHeight = logosHeight;

            btn.addEventListener('click', (e) => {
                if(e.currentTarget.classList.contains(STATIC.arrowUp)) {
                    logosModule.style.maxHeight = logosHeight;
                    logos[4].style.opacity = STATIC.opacity;
                    e.currentTarget.classList.remove(STATIC.arrowUp);
                }
                else {
                    logosModule.style.maxHeight = 'none';
                    logos[4].style.opacity = '1';
                    e.currentTarget.classList.add(STATIC.arrowUp);
                }
            })
        }
    }
}

export default logoMobile;